export default "__VITE_ASSET__AoflZABF__"